// extracted by mini-css-extract-plugin
export default {"avatarIcon":"Avatar_avatarIcon__494bL","avatarContainer":"Avatar_avatarContainer__bK-jN","dropdown":"Avatar_dropdown__r1hVu"};